var map = {
	"./merge-data-off.svg": "dTCb",
	"./merge-data-on.svg": "Y89U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4++N";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/query ^\.\/merge\-data\-.*\.svg$
// module id = 4++N
// module chunks = 46